<template>
  <a :href="downloadUrl" v-if="downloadUrl" class="download" download="download"
    >Download {{ appName || "Ask AI" }}</a
  >
</template>

<script lang="js">
export default {
  props: ["downloadUrl",'appName'],
};
</script>

<style lang="scss" scoped>
.download {
  position: fixed;
  bottom: 24px;
  left: 20px;
  right: 20px;
  padding: 20px 0;
  border-radius: 30px;
  box-shadow: 0 0 30px 0 #00000080;
  background-image: -webkit-linear-gradient(0deg, #f2ab49 0%, #4830bf 100%);
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  text-decoration: none;
}
</style>
